import { render, staticRenderFns } from "./ClockWidget.vue?vue&type=template&id=46f78371&scoped=true"
import script from "./ClockWidget.vue?vue&type=script&lang=js"
export * from "./ClockWidget.vue?vue&type=script&lang=js"
import style0 from "./ClockWidget.vue?vue&type=style&index=0&id=46f78371&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f78371",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f78371')) {
      api.createRecord('46f78371', component.options)
    } else {
      api.reload('46f78371', component.options)
    }
    module.hot.accept("./ClockWidget.vue?vue&type=template&id=46f78371&scoped=true", function () {
      api.rerender('46f78371', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/ClockWidget.vue"
export default component.exports